export default __webpack_public_path__ + "static/media/The Hindu Business Line.52b40435.png";